<div class="tile no-hover no-results-card"
  *transloco="let t; read: 'profile-list-no-results'">
  <img src="assets/images/no_results.png"
    aria-hidden="true"
    alt="">

  <div>
    <h3>{{ t(type() + '.heading') }}</h3>
    <div class="message"
      [innerHTML]="t(type() + '.message')"></div>
    <div>{{ t(type() + '.tips') }}</div>

    <ul role="list">
      <li>{{ t(type() + '.tip_1') }}</li>
      <li>{{ t(type() + '.tip_2') }}</li>
      @if (type() === 'page_limit_reached') {
        <li><a (click)="pageChange.emit(1)">{{ t(type() + '.tip_3') }}</a></li>
      }
    </ul>
  </div>
</div>